<template>
  <!--  验收整改审批页-->
  <div style="width: 100%;">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">办理</van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea" placeholder="请输入审批说明" />
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames" style="margin-top: 60px;">
      <van-collapse-item title="基本信息" name="1">
        <van-field label="验收类型" v-model="inputForm.acceptanceMark" input-align="left" readonly>
          <template #input>
            <span v-if="inputForm.acceptanceMark === '1'">分户验收</span>
            <span v-else-if="inputForm.acceptanceMark === '2'">承接查验</span>
            <span v-else>收楼验房</span>
          </template>
        </van-field>
        <van-field label="物业项目名称" v-model="inputForm.projectName" input-align="left" readonly autosize rows="1" type="textarea"></van-field>
        <van-field label="物业类型" v-model="inputForm.houseTypeName" input-align="left" readonly autosize rows="1" type="textarea" v-if="inputForm.acceptanceMark !== '2' && inputForm.resourceType == 1"></van-field>
        <div v-if="inputForm.acceptanceMark!== '2'">
          <van-field label="资源名称" v-model="inputForm.houseName" input-align="left" readonly autosize rows="1" type="textarea" v-if="inputForm.resourceType == 1"></van-field>
          <van-field label="资源名称" v-model="inputForm.areaName" input-align="left" readonly autosize rows="1" type="textarea" v-if="inputForm.resourceType == 2 || inputForm.resourceType == 3"></van-field>
        </div>
        <van-field :label="inspectionDateName" v-model="inputForm.inspectionDate" input-align="left" readonly></van-field>
        <van-field label="业主姓名" v-model="inputForm.propertyOwnerName" input-align="left" autosize rows="1" type="textarea" readonly v-if="inputForm.resourceType == 1 && inputForm.acceptanceMark == 3"></van-field>
        <van-field label="联系电话" v-model="inputForm.phone" input-align="left" readonly autosize rows="1" type="textarea" v-if="inputForm.resourceType == 1 && inputForm.acceptanceMark == 3"></van-field>
        <van-field :label="inspectorName" v-model="inputForm.inspector" input-align="left" readonly></van-field>
        <van-field label="问题类型" v-model="questionTypeName" input-align="left" autosize rows="1" type="textarea" readonly v-if="inputForm.acceptanceMark ==1 || inputForm.acceptanceMark == 3"></van-field>
        <van-field label="系统类型" v-model="systemTypeName" input-align="left" autosize rows="1" type="textarea" readonly v-if="inputForm.acceptanceMark ==2"></van-field>
        <van-field label="验收情况" type="textarea" v-model="inputForm.inspectionResult" autosize rows="1" input-align="left" readonly></van-field>
        <van-field label="要求完成时间" v-model="inputForm.completeDate" input-align="left"
                   readonly></van-field>
        <van-field label="照片" input-align="left" readonly>
          <template #input>
            <van-image
                v-for="(item, index) in inputForm.basicPhotoAttachList"
                :key="index"
                width="50"
                height="50"
                :src="item.url"
                @click="preview(inputForm.basicPhotoAttachList, index)"
            />
          </template>
        </van-field>
<!--        <div style="padding-left: 16px;" v-if="inputForm.basicAttachList.length > 0">-->
<!--          <p>附件</p>-->
<!--          <a style="display: block; color: #4caedc" v-for="(file, index) in inputForm.basicAttachList" :key="index" :href="file.url">{{file.name}}</a>-->
<!--        </div>-->
        <div style="padding-left: 16px;" v-show="inputForm.basicAttachList.length > 0">
          <p>附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.basicAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
<!--        <van-field label="附件" readonly input-align="left" label-width="4em">-->
<!--          <template #input>-->
<!--            <div style="display: flex; flex-direction: column" v-if="inputForm.basicAttachList.length > 0">-->
<!--              <a v-for="(item, index) in inputForm.basicAttachList" :key="index" :href="item.url">{{item.name}}</a>-->
<!--            </div>-->
<!--          </template>-->
<!--        </van-field>-->
      </van-collapse-item>
      <van-collapse-item title="处理意见" name="2" v-if="inputForm.proStatus >= 2">
        <van-field label="接收时间" input-align="left" v-model="inputForm.receiveTime" readonly></van-field>
        <van-field label="接收部门" input-align="left" v-model="inputForm.receiveDepartmentName" readonly></van-field>
        <van-field label="制单人" input-align="left" v-model="inputForm.regPersonName" readonly></van-field>
        <van-field label="处理意见" input-align="left" v-model="inputForm.proIdea" readonly>
          <template #input>
            <div v-if="inputForm.proIdea === '1'">整改</div>
            <div v-else>暂不整改</div>
          </template>
        </van-field>
        <van-field label="整改方案" input-align="left" v-model="inputForm.reformIdea" readonly autosize rows="1" type="textarea"></van-field>
<!--        <div style="padding-left: 16px;" v-if="inputForm.proAttachList.length > 0">-->
<!--          <p>附件</p>-->
<!--          <a style="display: block; color: #4caedc" v-for="(file, index) in inputForm.proAttachList" :key="index" :href="file.url">{{file.name}}</a>-->
<!--        </div>-->
        <div style="padding-left: 16px;" v-show="inputForm.proAttachList.length > 0">
          <p>附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.proAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
<!--        <van-field label="附件" readonly input-align="left">-->
<!--          <template #input>-->
<!--            <div style="display: flex; flex-direction: column" v-if="inputForm.proAttachList.length > 0">-->
<!--              <a v-for="(item, index) in inputForm.proAttachList" :key="index" :href="item.url">{{item.name}}</a>-->
<!--            </div>-->
<!--          </template>-->
<!--        </van-field>-->
      </van-collapse-item>
      <van-collapse-item title="整改情况" name="3" v-if="inputForm.proStatus > 2 && inputForm.proStatus != 6 && inputForm.proIdea == 1">
        <van-field label="完成情况" input-align="left" v-model="inputForm.completedStatus" readonly>
          <template #input>
            <div v-if="inputForm.completedStatus === '1'">全部完成</div>
            <div v-else>部分完成</div>
          </template>
        </van-field>
        <van-field label="完成时间" input-align="left" v-model="inputForm.completionTime" readonly></van-field>
        <van-field label="遗留情况说明" input-align="left" v-model="inputForm.legacyStatement" readonly
                   v-if="inputForm.completedStatus == 2" autosize rows="1" type="textarea"></van-field>
        <van-field label="照片" readonly input-align="left">
          <template #input>
            <van-image
                v-for="(item, index) in inputForm.reformPhotoAttachList"
                :key="index"
                width="50"
                height="50"
                :src="item.url"
                @click="preview(inputForm.reformPhotoAttachList, index)"
            />
          </template>
        </van-field>
<!--        <div style="padding-left: 16px;" v-if="inputForm.rectifyAttachList.length > 0">-->
<!--          <p>附件</p>-->
<!--          <a style="display: block; color: #4caedc" v-for="(file, index) in inputForm.rectifyAttachList" :key="index" :href="file.url">{{file.name}}</a>-->
<!--        </div>-->
        <div style="padding-left: 16px;" v-show="inputForm.rectifyAttachList.length > 0">
          <p>附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.rectifyAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
<!--        <van-field label="附件" readonly input-align="left" label-width="4em">-->
<!--          <template #input>-->
<!--            <div style="display: flex; flex-direction: column" v-if="inputForm.rectifyAttachList.length > 0">-->
<!--              <a v-for="(item, index) in inputForm.rectifyAttachList" :key="index" :href="item.url">{{item.name}}</a>-->
<!--            </div>-->
<!--          </template>-->
<!--        </van-field>-->
      </van-collapse-item>
      <van-collapse-item title="复查情况" name="4" v-if="inputForm.proStatus >= 4 && inputForm.proStatus != 6 && inputForm.pageMark !== '1' && inputForm.recheckShow !== ''">
        <van-field label="复查时间" input-align="left" v-model="inputForm.acceptDate" readonly autosize rows="1" type="textarea"></van-field>
        <van-field label="复查说明" input-align="left" v-model="inputForm.recheckShow" readonly autosize rows="1" type="textarea"></van-field>
        <van-field label="复查结果" input-align="left" v-model="inputForm.recheckResult" readonly>
          <template #input>
            <div v-if="inputForm.recheckResult === '1'">通过</div>
            <div v-else>不通过</div>
          </template>
        </van-field>
        <van-field label="照片" readonly input-align="left">
          <template #input>
            <van-image
                v-for="(item, index) in inputForm.reviewPhotoAttachList"
                :key="index"
                width="50"
                height="50"
                :src="item.url"
                @click="preview(inputForm.reviewPhotoAttachList, index)"
            />
          </template>
        </van-field>
<!--        <div style="padding-left: 16px;" v-if="inputForm.reviewAttachList.length > 0">-->
<!--          <p>附件</p>-->
<!--          <a style="display: block; color: #4caedc" v-for="(file, index) in inputForm.reviewAttachList" :key="index" :href="file.url">{{file.name}}</a>-->
<!--        </div>-->
        <div style="padding-left: 16px;" v-show="inputForm.reviewAttachList.length > 0">
          <p>附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.reviewAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
<!--        <van-field label="附件" readonly input-align="left" label-width="4em">-->
<!--          <template #input>-->
<!--            <div v-if="inputForm.reviewAttachList.length > 0">-->
<!--              <a style="display:block;color: #4caedc" v-for="(item, index) in inputForm.reviewAttachList" :key="index" :href="item.url">{{item.name}}</a>-->
<!--            </div>-->
<!--          </template>-->
<!--        </van-field>-->
      </van-collapse-item>
    </van-collapse>

    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import InfacyHouseholdAcceptanceService from "../../api/infacy/InfacyHouseholdAcceptanceService";
import InspectionRectifyService from "../../api/inspectionRectify/inspectionRectifyService";
import TaskService from '@/api/flowable/TaskService.js'
import ProcessService from '@/api/flowable/ProcessService'
import {ImagePreview} from "vant";
import processRecord from "../../components/processRecord/processRecord";
export default {
  name: "undertakeInspection",
  data(){
    return {
      inputForm: {
        basicPhotoAttachList: [],
        basicAttachList: [],
        proAttachList: [],
        reformPhotoAttachList: [],
        rectifyAttachList: [],
        reviewPhotoAttachList: [],
        reviewAttachList: [],
        systemTypeId: '',
        questionTypeId: [],
        isDoTask: false,
        isLastTask: false
      },
      activeNames: ['1', '2', '3', '4'],
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      isshow: false,
      systemTypeName: '',
      questionTypeName: '',
      infacyHouseholdAcceptanceService: null,
      inspectionRectifyService: null
    }
  },
  created() {
    this.infacyHouseholdAcceptanceService = new InfacyHouseholdAcceptanceService()
    this.inspectionRectifyService = new InspectionRectifyService()
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.init(id)

  },
  components: {
    processRecord
  },
  computed: {
    inspectionDateName() {
      return this.inputForm.acceptanceMark == 3 ? '验房日期' : '验收日期'
    },
    inspectorName() {
      return this.inputForm.acceptanceMark == 3 ? '陪验人员' : '验收人'
    },
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryById(id, '/infacy/wuyeInfacyMain/queryById').then(({ data }) => {
        this.inputForm = data
        if(this.inputForm.acceptanceMark == 2) {
          this.infacyHouseholdAcceptanceService.questionTypelist({type: '2'}).then((res) => {
            let tempArr = []
            res.data.forEach(item => {
              if(this.inputForm.systemTypeId == item.id) {
                tempArr.push(item.name)
              }

            })
            this.systemTypeName = tempArr.join(',')
          })
        } else {
          this.infacyHouseholdAcceptanceService.questionTypelist({type: '1'}).then((res) => {
            let tempArr = []
            res.data.forEach(item => {
              this.inputForm.questionTypeId.forEach(key => {
                if(item.id === key) {
                  tempArr.push(item.name)
                }
              })
            })
            this.questionTypeName = tempArr.join(',')
          })
        }
      }).catch(e => {
        console.log(e)
      })
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          if(this.inputForm.pageMark === '1') {
            this.inspectionRectifyService.saveProInsId(this.inputForm).then(()=> {
              _this.$toast.clear();
              _this.$toast.success('提交成功');
              //更新数据库状态
              _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
              _this.$flow.startFlow(_this.inputForm, '/infacy/wuyeInfacyMain/startFlow');

              setTimeout(function () {
                _this.close()
              }, 800)
            })
          } else {
            _this.$toast.clear();
            _this.$toast.success('提交成功');
            //更新数据库状态
            _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
            _this.$flow.startFlow(_this.inputForm, '/infacy/wuyeInfacyMain/startFlow');

            setTimeout(function () {
              _this.close()
            }, 800)
          }

        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = 3;
          _this.$flow.startFlow(_this.inputForm, '/infacy/wuyeInfacyMain/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    //  图片预览
    preview(data, index) {
      let picList = []
      data.forEach(item => {
        picList.push(item.url)
      })
      ImagePreview({
        images: picList,
        closeable: true,
        startPosition: index,
      })
    }
  }
}
</script>

<style scoped>

</style>